export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Selected-Gray-21ab4075b73b69d63b351603776cbf0c.svg";